"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WebmasterComponent = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _axios = _interopRequireDefault(require("axios"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _buttonControl = _interopRequireDefault(require("../button-control"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WebmasterSetup = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(WebmasterSetup, _Component);

  var _super = _createSuper(WebmasterSetup);

  function WebmasterSetup(props) {
    var _this;

    (0, _classCallCheck2.default)(this, WebmasterSetup);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      loading: false
    };
    _this.setWebmaster = _this.setWebmaster.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(WebmasterSetup, [{
    key: "setWebmaster",
    value: function () {
      var _setWebmaster = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(isSecondary, _ref) {
        var name, email;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                name = _ref.name, email = _ref.email;
                this.setState({
                  loading: true
                });
                _context.prev = 2;
                _context.next = 5;
                return _axios.default.post('/settings/emailManagement/saveWebmaster', {
                  email: email,
                  name: name,
                  secondary: isSecondary
                });

              case 5:
                this.setState({
                  loading: false
                });
                window.location.reload();
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                this.setState({
                  loading: false
                }); // eslint-disable-next-line no-console

                console.log('e ', _context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function setWebmaster(_x, _x2) {
        return _setWebmaster.apply(this, arguments);
      }

      return setWebmaster;
    }()
  }, {
    key: "render",
    value: function render() {
      if (this.props.emails.length === 0) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: "email-setup"
      }, (0, _preact.h)("h3", null, "Email Setup"), (0, _preact.h)(WebmasterComponent, {
        loading: this.state.loading,
        emails: this.props.emails,
        email: this.props.webmaster.length > 0 ? this.props.webmaster[0] : '',
        name: this.props.name,
        isSecondary: false,
        title: "System emails:",
        setWebmaster: this.setWebmaster
      }), (0, _preact.h)(WebmasterComponent, {
        loading: this.state.loading,
        emails: this.props.emails,
        email: this.props.secondaryWebmaster.length > 0 ? this.props.secondaryWebmaster[0] : '',
        name: this.props.secondaryName,
        isSecondary: true,
        title: "Email campaigns:",
        setWebmaster: this.setWebmaster
      }));
    }
  }]);
  return WebmasterSetup;
}(_preact.Component);

var WebmasterComponent = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(WebmasterComponent, _Component2);

  var _super2 = _createSuper(WebmasterComponent);

  function WebmasterComponent() {
    var _this2;

    (0, _classCallCheck2.default)(this, WebmasterComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "state", {
      // eslint-disable-next-line react/no-unused-state
      emails: _this2.props.emails,
      email: _this2.props.email,
      name: _this2.props.name
    });
    return _this2;
  }

  (0, _createClass2.default)(WebmasterComponent, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          email = _this$props.email,
          title = _this$props.title,
          name = _this$props.name,
          emails = _this$props.emails,
          loading = _this$props.loading,
          isSecondary = _this$props.isSecondary,
          setWebmaster = _this$props.setWebmaster;
      return (0, _preact.h)("div", {
        className: "form"
      }, (0, _preact.h)("div", {
        className: "row"
      }, (0, _preact.h)("label", {
        htmlFor: "webmaster"
      }, title), (0, _preact.h)(_InputGroup.default, {
        type: "text",
        placeholder: "eg: Insided Community",
        value: name,
        onChange: function onChange(e) {
          return _this3.setState({
            name: e.target.value
          });
        }
      }), (0, _preact.h)("select", {
        className: "webmasterSelector",
        onChange: function onChange(e) {
          _this3.setState({
            email: e.target.value
          });
        }
      }, (0, _preact.h)("option", {
        disabled: true,
        selected: !email
      }, "Select your option"), emails.map(function (currentEmail, index) {
        return (0, _preact.h)("option", {
          key: index,
          selected: !!email && currentEmail === email
        }, currentEmail);
      })), (0, _preact.h)(_buttonControl.default, {
        variant: "success",
        title: "Save",
        isLoading: loading,
        disabled: !this.state.email,
        onClick: function onClick() {
          return setWebmaster(isSecondary, {
            email: _this3.state.email,
            name: _this3.state.name
          });
        }
      })));
    }
  }]);
  return WebmasterComponent;
}(_preact.Component);

exports.WebmasterComponent = WebmasterComponent;
var _default = WebmasterSetup;
exports.default = _default;